import PropTypes from "prop-types";
import Title from "components/adventure/Title";
import Text from "components/adventure/Text";
import PhotoCloudfront from "components/shared/adventures/PhotoCloudfront";
import styles from "components/adventure/Highlight.module.scss";
import Image from "next/image";
import cn from "classnames";

export default function Highlight({ photo, name, description }) {
  const sizeString = `(max-width: ${styles.solBreakpointLg}px) 100vw, (max-width: ${styles.solBreakpointXl}px) 50vw, 100vw`;

  return (
    <div className={styles.component}>
      {photo &&
        (photo.url ? (
          <PhotoCloudfront
            src={photo.url}
            width={photo.width}
            height={photo.height}
            sizeTemplate="half"
            rounded
            className={styles.photo}
            alt={name}
          />
        ) : (
          <Image
            src={photo}
            width={photo?.width}
            height={photo?.height}
            placeholder="blur"
            className={cn(styles.image, styles.rounded, styles.photo)}
            sizes={sizeString}
            alt={name}
          />
        ))}
      <div>
        <Title size="sm" className={styles.name}>
          {name}
        </Title>
        <Text size="sm">{description}</Text>
      </div>
    </div>
  );
}

Highlight.propTypes = {
  photo: PropTypes.shape({
    url: PropTypes.string,
    content_type: PropTypes.string,
    byte_size: PropTypes.number,
    width: PropTypes.number,
    height: PropTypes.number,
  }).isRequired,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
